<template>
  <div class="el-input-sanitize-wrapper">
    <el-input
      v-model="internalValue" 
      :disabled="props.disabled"
      v-bind="$attrs"
      onafterpaste="this.value=this.value.replace(/[^\u4E00-\u9FA5A-Za-z0-9 ]/g, '')" 
      @blur="handleBlur" 
      @focus="handleFocus" 
      @change="handleChange" 
      @input="handleInput"
      @clear="handleClear" 
    />
  </div>
</template>

<script setup>
import { watch, onMounted } from 'vue';
import { useVModel } from '@vueuse/core'

const props = defineProps({
  modelValue: String,
  disabled: Boolean,
});

const emit = defineEmits(['update:modelValue', 'input', 'blur', 'focus', 'change', 'clear', 'error']);

const internalValue = useVModel(props, 'modelValue', emit);

const sanitize = (val) => {
  // 只允許中文、數字、英文(大小寫)和空格
  const sanitizedVal = val?.replace(/[^\u4E00-\u9FA5A-Za-z0-9 ]/g, '') || '';
  return sanitizedVal;
};

const handleInit = () => {
  const sanitizedValue = sanitize(props.modelValue);
  internalValue.value = sanitizedValue;
  emit('input', sanitizedValue);
};

watch(() => props.modelValue, (newVal) => {
  internalValue.value = newVal;
});

watch(internalValue, (newVal) => {
  const sanitizedValue = sanitize(newVal);
  if (sanitizedValue !== newVal) {
    internalValue.value = sanitizedValue;
  }
  emit('input', sanitizedValue);
});

onMounted(handleInit);

const handleBlur = (event) => {
  emit('blur', event);
};

const handleFocus = (event) => {
  emit('focus', event);
};

const handleChange = (value) => {
  emit('change', value);
};

const handleInput = (value) => {
  const sanitizedValue = sanitize(value);
  internalValue.value = sanitizedValue;
  emit('input', sanitizedValue);
};

const handleClear = () => {
  emit('clear');
};
</script>

<style lang="scss">
.el-input-sanitize-wrapper {
  margin: 0;
  padding: 0;
  width: 100%;
}
</style>
